export default "__VITE_ASSET__Bnovr28N__"